module.exports = __webpack_public_path__ + "img/Layer_9.046101c1.png";